import { Middleware } from '@reduxjs/toolkit';
import { showConfirmation } from '@/redux/slices/confirmation';

const derivedActionMeta = (action: any) => {
  if (action?.meta?.arg?.meta) {
    return action?.meta?.arg?.meta;
  }
  return action?.payload?.meta;
};

export const confirmationMiddleware: Middleware = (store) => (next) => (action: any) => {
  const actionMeta = derivedActionMeta(action);
  // Check if this action needs confirmation
  if (actionMeta?.confirm && !actionMeta.confirmed) {
    store.dispatch(
      showConfirmation({
        title: actionMeta.confirm.title || 'Are you sure?',
        subtitle: actionMeta.confirm.subtitle,
        confirmButton: {
          text: actionMeta.confirm.confirmButton?.text || 'Confirm',
          variant: actionMeta.confirm.confirmButton?.variant || 'primary',
        },
        cancelButton: {
          text: actionMeta.confirm.cancelButton?.text || 'Cancel',
          variant: actionMeta.confirm.cancelButton?.variant || 'secondary',
        },
        actionType: action.type,
        actionPayload: {
          ...action.payload,
          meta: { ...actionMeta, confirmed: true },
        },
      }),
    );
    return; // Stop the action
  }

  // Normal flow for all other actions
  return next(action);
};
